export default {
  license: {
    // expired: 'The seller license has exprired.',
    // close_button: 'Close'
  },
  cart: {
    title_noproductsincart: 'Корзина товаров пуста.',
    cta_goback: 'Вернуться к списку продуктов',
    title_cart: 'Корзина:',
    title_totalamount: 'Общая сумма:',
    title_discountedamount: 'Цена со скидкой',
    title_coupon: 'купон',
    coupon_cta_apply: 'Подать заявление',
    coupon_placeholder: 'купон',
    cta_remove_product: 'Remove',
  },
  checkout: {
    title_back: 'Назад',
    title_back_description: 'Вернуться к списку товаров.',
    // total: 'Total',
    // shipping: 'Shipping'
  },
  footer: {
    banner: 'Sell on your own website with <a href="{link}" target="_blank">{name}</a>.'
  },
  form: {
    error_blank: 'Это поле не может быть пустым ',
  },
  payment_list: {
    title_partial: 'Оплатите только часть суммы.',
    title_installations: 'Установка:',

    option_installment: '{installment} * {currency} with a total of {total}',
    title_paysecurely: 'Платите безопасно ',
    title_securepayment: 'Ваши платежи защищены 256-битным шифрованием военного класса.',

    info_emptycart: 'Your cart is empty. Add a product to make a payment.'
  },
  product: {
    title_selection: 'Выбор продукта:',
    title_price: 'Цена:',
    cta_addtocart: 'Добавить в корзину ({price})',
    title_amountselection: 'Продукт временно недоступен:',
    title_closedforsale: 'Продукт временно недоступен.',
    cta_checkoutpage: 'Перейти к оформлению заказа'
  },
  sort: {
    label: 'Заказ:',
    default: 'По умолчанию',
    price_asc: 'Цена по возрастанию',
    price_desc: 'Цена по убыванию'
  },
  category: {
    label: 'Category:',
    default: 'Default',
  },
  modifiers: {
    unselect: 'Unselect'
  },
  summary: {
    coupon_cta_apply: 'Подать заявление',
    coupon_placeholder: 'купон'
  }
};



// WEBPACK FOOTER //
// ./src/lang/ru.js